import { render, staticRenderFns } from "./edit-companyinformation.vue?vue&type=template&id=24e64c76&"
import script from "./edit-companyinformation.vue?vue&type=script&lang=ts&"
export * from "./edit-companyinformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-companyinformation.vue"
export default component.exports